export default {
  FETCH_ARTICLE_CONTENT: 'FETCH_ARTICLE_CONTENT',
  FETCH_ARTICLE_CONTENT_SUCCESS: 'FETCH_ARTICLE_CONTENT_SUCCESS',
  FETCH_ARTICLE_CONTENT_FAILURE: 'FETCH_ARTICLE_CONTENT_FAILURE',

  FETCH_ARTICLE_META: 'FETCH_ARTICLE_META',
  FETCH_ARTICLE_META_SUCCESS: 'FETCH_ARTICLE_META_SUCCESS',
  FETCH_ARTICLE_META_FAILURE: 'FETCH_ARTICLE_META_FAILURE',

  FETCH_ARTICLE_TAGS: 'FETCH_ARTICLE_TAGS',
  FETCH_ARTICLE_TAGS_SUCCESS: 'FETCH_ARTICLE_TAGS_SUCCESS',
  FETCH_ARTICLE_TAGS_FAILURE: 'FETCH_ARTICLE_TAGS_FAILURE',

  FETCH_ARTICLE_RELATED_COMMUNITIES: 'FETCH_ARTICLE_RELATED_COMMUNITIES',
  FETCH_ARTICLE_RELATED_COMMUNITIES_SUCCESS: 'FETCH_ARTICLE_RELATED_COMMUNITIES_SUCCESS',
  FETCH_ARTICLE_RELATED_COMMUNITIES_FAILURE: 'FETCH_ARTICLE_RELATED_COMMUNITIES_FAILURE',
};
